export default __webpack_public_path__ + "static/googleAdManager-4ed554a9779fef1b63688905d486d4c7.svg";